import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/app/ui/views/pickup/list-pickup-v2/list/assets/waiting-courier.svg'
import _imports_1 from '@/app/ui/views/pickup/list-pickup-v2/list/assets/pickup-package.svg'
import _imports_2 from '@/app/ui/views/pickup/list-pickup-v2/list/assets/pickup-done.svg'
import _imports_3 from '@/app/ui/views/pickup/list-pickup-v2/list/assets/processed-agent-hub.svg'


const _hoisted_1 = { class: "w-full grid grid-cols-4 gap-3" }
const _hoisted_2 = { class: "flex items-center gap-2" }
const _hoisted_3 = { class: "mt-1.5 flex items-center gap-2" }
const _hoisted_4 = { class: "flex items-center gap-2" }
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "clock"
}, null, -1)
const _hoisted_6 = { class: "text-sm font-semibold text-black-lp-100" }
const _hoisted_7 = { class: "mt-1.5 flex items-center gap-2" }
const _hoisted_8 = { class: "text-2xl font-semibold text-black-lp-100" }
const _hoisted_9 = { class: "text-sm font-medium text-gray-lp-800" }
const _hoisted_10 = { class: "flex items-center gap-2" }
const _hoisted_11 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  alt: "clock"
}, null, -1)
const _hoisted_12 = { class: "text-sm font-semibold text-black-lp-100" }
const _hoisted_13 = { class: "mt-1.5 flex items-center gap-2" }
const _hoisted_14 = { class: "text-2xl font-semibold text-black-lp-100" }
const _hoisted_15 = { class: "text-sm font-medium text-gray-lp-800" }
const _hoisted_16 = { class: "flex items-center gap-2" }
const _hoisted_17 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  alt: "clock"
}, null, -1)
const _hoisted_18 = { class: "text-sm font-semibold text-black-lp-100" }
const _hoisted_19 = { class: "mt-1.5 flex items-center gap-2" }
const _hoisted_20 = { class: "text-2xl font-semibold text-black-lp-100" }
const _hoisted_21 = { class: "text-sm font-medium text-gray-lp-800" }
const _hoisted_22 = { class: "flex items-center gap-2" }
const _hoisted_23 = /*#__PURE__*/_createVNode("img", {
  src: _imports_3,
  alt: "clock"
}, null, -1)
const _hoisted_24 = { class: "text-sm font-semibold text-black-lp-100" }
const _hoisted_25 = { class: "mt-1.5 flex items-center gap-2" }
const _hoisted_26 = { class: "text-2xl font-semibold text-black-lp-100" }
const _hoisted_27 = { class: "text-sm font-medium text-gray-lp-800" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, _renderList(4, (index) => {
          return _createVNode(_component_Card, {
            key: index,
            rounded: "xl",
            isShadow: false,
            class: "p-4",
            style: {
          backgroundImage: `url(${require('@/app/ui/assets/svg/bg-summary-limit.svg')})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'top right',
          backgroundSize: '-100% 50%'
        }
          }, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_2, [
                _createVNode(_component_Skeleton, {
                  height: "1.25rem",
                  width: "1.25rem"
                }),
                _createVNode(_component_Skeleton, {
                  height: "1.5rem",
                  width: "9rem"
                })
              ]),
              _createVNode("div", _hoisted_3, [
                _createVNode(_component_Skeleton, {
                  height: "1.25rem",
                  width: "1rem"
                }),
                _createVNode(_component_Skeleton, {
                  height: "1.25rem",
                  width: "6rem"
                })
              ])
            ]),
            _: 2
          }, 1032, ["style"])
        }), 64))
      : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
          _createVNode(_component_Card, {
            rounded: "xl",
            isShadow: false,
            class: "p-4",
            style: {
          backgroundImage: `url(${require('@/app/ui/assets/svg/bg-summary-limit.svg')})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'top right',
          backgroundSize: '-100% 50%'
        }
          }, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_4, [
                _hoisted_5,
                _createVNode("h3", _hoisted_6, _toDisplayString(_ctx.$t("pickupV2.list.summary.waitingCourier")), 1)
              ]),
              _createVNode("div", _hoisted_7, [
                _createVNode("span", _hoisted_8, _toDisplayString(_ctx.formatNumber(_ctx.data.waitingCourier)), 1),
                _createVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("pickupV2.list.summary.pickUp")), 1)
              ])
            ]),
            _: 1
          }, 8, ["style"]),
          _createVNode(_component_Card, {
            rounded: "xl",
            isShadow: false,
            class: "p-4",
            style: {
          backgroundImage: `url(${require('@/app/ui/assets/svg/bg-summary-limit.svg')})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'top right',
          backgroundSize: '-100% 50%'
        }
          }, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_10, [
                _hoisted_11,
                _createVNode("h3", _hoisted_12, _toDisplayString(_ctx.$t("pickupV2.list.summary.pickUpPackage")), 1)
              ]),
              _createVNode("div", _hoisted_13, [
                _createVNode("span", _hoisted_14, _toDisplayString(_ctx.formatNumber(_ctx.data.pickUpPackage)), 1),
                _createVNode("span", _hoisted_15, _toDisplayString(_ctx.$t("pickupV2.list.summary.pickUp")), 1)
              ])
            ]),
            _: 1
          }, 8, ["style"]),
          _createVNode(_component_Card, {
            rounded: "xl",
            isShadow: false,
            class: "p-4",
            style: {
          backgroundImage: `url(${require('@/app/ui/assets/svg/bg-summary-limit.svg')})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'top right',
          backgroundSize: '-100% 50%'
        }
          }, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_16, [
                _hoisted_17,
                _createVNode("h3", _hoisted_18, _toDisplayString(_ctx.$t("pickupV2.list.summary.pickUpCompleted")), 1)
              ]),
              _createVNode("div", _hoisted_19, [
                _createVNode("span", _hoisted_20, _toDisplayString(_ctx.formatNumber(_ctx.data.pickUpDone)), 1),
                _createVNode("span", _hoisted_21, _toDisplayString(_ctx.$t("pickupV2.list.summary.pickUp")), 1)
              ])
            ]),
            _: 1
          }, 8, ["style"]),
          _createVNode(_component_Card, {
            rounded: "xl",
            isShadow: false,
            class: "p-4",
            style: {
          backgroundImage: `url(${require('@/app/ui/assets/svg/bg-summary-limit.svg')})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'top right',
          backgroundSize: '-100% 50%'
        }
          }, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_22, [
                _hoisted_23,
                _createVNode("h3", _hoisted_24, _toDisplayString(_ctx.$t("pickupV2.list.summary.processedAgentHub")), 1)
              ]),
              _createVNode("div", _hoisted_25, [
                _createVNode("span", _hoisted_26, _toDisplayString(_ctx.formatNumber(_ctx.data.agentHub)), 1),
                _createVNode("span", _hoisted_27, _toDisplayString(_ctx.$t("pickupV2.list.summary.pickUp")), 1)
              ])
            ]),
            _: 1
          }, 8, ["style"])
        ], 64))
  ]))
}